<script setup>

import { defineProps, reactive } from 'vue';
import watermark from 'watermarkjs';

import TakingPhoto from '@/components/dialogs/TakingPhotoV2.vue';



const props = defineProps({
    imageText: String,
    imageSrc: String,
    changeHandle: Function,
    clearHandle: Function,
    imgType: Object,
});

const componentData = reactive({
    showTakingPhoto: false,
    takingName: '',
    takingPhotoParams: {
        title: '請拍攝身分證',
        content: '',
        confirmButton: '拍攝', // 不傳不顯示
        isErrorButton: false, // 確認是紅色按鈕嗎？紅色：藍色
        isDisabledButton: false,
        cancelButton: '取消',
    },
});

const watermarkText = reactive({
    text: '僅供富邦人壽視訊確認作業使用',
    font: '26px Josefin Slab',
    color: '#fff',
    shade: 0.5,
})

const saveImage = (imgData) => {
    watermark([imgData]).image(watermark.text.center(watermarkText.text, watermarkText.font, watermarkText.color, watermarkText.shade)).then(async (img) => {
        const result = await (await fetch(img.src)).blob();
        props.changeHandle(result)
    });
    componentData.showTakingPhoto = false;
};

const taking = (imageData) => {
    componentData.takingName = imageData.name;
    componentData.takingPhotoParams.title = imageData.title;
    componentData.showTakingPhoto = true;
};

</script>

<template>

    <div class="w-full min-h-[220px] bg-[#DFE4E5] rounded-md">

        <div class="p-4" v-if="imageSrc">
            <div class="w-full flex justify-between items-center pb-4">
                <div class="font-bold">{{ imageText }}</div>
                <div>
                    <button @click="clearHandle">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2 5L22 5" stroke="#0093C1" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path
                                d="M4 6L5.93247 19.5273C6.13516 20.9461 7.35029 22 8.78352 22H15.2165C16.6497 22 17.8648 20.9461 18.0675 19.5273L20 6"
                                stroke="#0093C1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M9.46387 8.26855V17.4881" stroke="#0093C1" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M14.293 8.48828V17.7078" stroke="#0093C1" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path
                                d="M7.70752 4.63415C7.94699 3.7561 9.09643 2 11.7785 2C14.4605 2 15.4503 3.7561 15.61 4.63415"
                                stroke="#0093C1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </button>
                </div>
            </div>

            <div class="text-center">
                <img class="inline-block max-w-[220px]" id="imgInput" :src="imageSrc" />
            </div>
        </div>

        <label @click="taking(imgType)" class="block w-full h-[220px] relative" v-else>
            <input class="w-full h-full opacity-0 relative z-20" type="file" id="uploader" capture="environment"
                accept="image/*" @change="changeHandle" @click="(event) => { event.preventDefault() }" />
            <div class="absolute top-0 left-0 right-0 bottom-0 z-10 flex items-center justify-center text-center">
                <div>
                    <div class="inline-block pb-2">
                        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12.5" cy="12" r="10" fill="#0093C1" />
                            <path d="M12.5 7.5V16.4999" stroke="white" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M17 12H8.00009" stroke="white" stroke-width="1.95" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div class="font-bold">拍攝{{ imageText }}</div>
                </div>
            </div>
        </label>
        <TakingPhoto :visible-popup="componentData.showTakingPhoto" :params="componentData.takingPhotoParams"
            @confirm="saveImage" @cancel="componentData.showTakingPhoto = false" />
    </div>

</template>

<style></style>